import axios from "axios";
import { toast } from "react-toastify";
 // baseURL: "http://localhost:8080/api", // your backend
  //baseURL: "http://35.154.221.235:8080/api", // AWS backend
const axiosInstance = axios.create({
   baseURL: "https://api.avyb.in/api", // AWS backend
});

// Attach token automatically
axiosInstance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    const academicYearId = sessionStorage.getItem("academicYearId");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
     if (academicYearId) {
        config.headers["X-Academic-Year"] = Number(academicYearId);
      }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      toast.error("Loggin Expired, Please Relogin");
      //toast.error("Session expired. Please logOut & login again.");
      sessionStorage.clear();
      window.location.href = "/login";
    }else  if (error.response && error.response.status === 403) {
     // alert("Aceess Denied");
      toast.error("Aceess Denied.");
       //window.location.href = "/unauthorized";
    }else  if (error.response && error.response.status === 500) {
        //alert("Technical Error Occured");
        toast.error("Technical Error Occured.");
       //window.location.href = "/unauthorized";
    }else{
      toast.error("Validation Errors Exist");
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;